module.exports = __webpack_public_path__ + "img/success-with-woodpacking-en.160a6cb2.svg";